<template>
  <div class="whiteBox whiteBoxDashboard workspace_notPaid">
    Waiting payment....
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>

<style scoped></style>
